import { CognitoUserPool } from "amazon-cognito-identity-js";

const poolData = {
    UserPoolId: "eu-central-1_PX9YDakfF",
    ClientId: "4f6vq3mglahto3evq2nq0ucrfr",
};

export default new CognitoUserPool(poolData);
